import { Injectable } from '@angular/core';

// store
import { Store } from '@ngrx/store';
import {
    AppState,
    UPDATE_FORM_DATA,
    ADD_QUESTIONS,
    ADD_APP_ID,
    ADD_APPLICATION_ID,
    RESET_CONTENT,
    UPDATE_PERSONA,
    RESET_DECISION_INFO,
    UPDATE_EXPIRED
} from '../app-reducer';

// reactive
import { Observable, forkJoin } from 'rxjs';

// services
import { ApiService } from 'src/app/services/api.service';
import { QuestionService } from '../services/question.service';

// utilities
import { get, sortBy } from 'lodash';

@Injectable({
    providedIn: 'root'
})

export class ComposableService {
    appState$: Observable<any>;
    constructor(
        private apiService: ApiService,
        private store: Store<AppState>,
        private questionService: QuestionService
    ) {
        this.appState$ = this.store.select('sections');
    }

    // bootstrap the application
    bootstrap() {
        // get data
        forkJoin([
			this.apiService.getStates(),
            this.apiService.getRawData(),
            this.apiService.getDependencies(),
            this.apiService.getCountries(),
            this.apiService.getMedications()
		]).subscribe(([statesRaw, dataRaw, dependencies, countries, medicationsRaw]: any) => {


            // transform to states options
            let states = statesRaw.states.map((item: any) => {
                item.key = item.abbreviation;
                item.value = item.name;

                return item;
            });
            
            // transform to medications options
            const medications = medicationsRaw.medications.map((x) => {
                const item = {
                key : x,
                value : x,
                Name: x
                }
				return item;
            });

            // sort data
            states = sortBy(states, ['name']);

            // create data object
            const optionsData = {
				states,
                countries: countries.CountryLists,
                medications
            };

            this.store.dispatch({
                type: UPDATE_FORM_DATA,
                payload: optionsData
            });

             // generate questions object
            const questions = this.questionService.generateQuestions(dataRaw.QuestionBlocks, dependencies, optionsData);

            // update store
			this.store.dispatch({
				type: ADD_QUESTIONS,
				payload: questions
            });
        })
    }

    // reset application state
    resetApplication() {
        // update store
        this.store.dispatch({
            type: ADD_APP_ID,
            payload: null
        });

        // update store
        this.store.dispatch({
            type: ADD_APPLICATION_ID,
            payload: null
        });

        // update store
        this.store.dispatch({
            type: RESET_CONTENT
        });

        // update store
        this.store.dispatch({
            type: RESET_DECISION_INFO
        });

        // erase persona settings to prevent "read only" persisting into agent's next session
        this.store.dispatch({
            type: UPDATE_PERSONA,
            payload: { customerSigned: 0 }
        });
        
        this.store.dispatch({
            type: UPDATE_EXPIRED,
            payload: false
        });
    }

    sessionExpired() {
        this.store.dispatch({
            type: UPDATE_EXPIRED,
            payload: true
        });
    }
}
